
const StatusBadge = ({ status }) => {
    if (!status) return null;
    const statusStyles = {
        REDEEMED: 'bg-gg-green text-white',
        PAID: 'bg-gg-dark text-white',
        INIT: 'bg-yellow-300 text-yellow-800',
    };

    const style = statusStyles[status] || 'bg-red-300 text-red-800';

    const statusString = status === "INIT" ? "Pending " : status == "PAID" ? "To collect" : status.toLowerCase();

    return (
        <span className={`px-2 py-1 rounded text-xs capitalize ${style}`}>
            {statusString}
        </span>
    );
}

export default StatusBadge;